module.exports = __webpack_public_path__ + "3ec57fe0a1672546952cd740d3b97e53.svg";